import { createFileRoute } from "@tanstack/react-router";

import { listContent } from "@/lib/cms.functions";
import { normalizeLocale } from "@/lib/i18n";
import { pageHead } from "@/content/seo-pages";
import { PageHero } from "@/components/site/ContentViews";
import {
  ContentHubSkeleton,
  FilteredContentGrid,
} from "@/components/site/ContentFilters";
import { Section } from "@/components/site/Section";
import { ClosingCta } from "@/components/site/Cta";
import { FaqSection } from "@/components/site/FaqSection";
import { NEWS_FAQ } from "@/content/industry-faq";
import { faqScript } from "@/lib/faq-schema";

export const Route = createFileRoute("/{-$locale}/news/")({
  staticData: { sitemap: true },
  loader: async ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const items = await listContent({ data: { kind: "news", locale } });
    return { locale, items };
  },
  head: ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const head = pageHead("/news", locale, {
      title: "News | factory.online",
      description:
        "Product releases, company updates and manufacturing events from the factory.online team.",
    });
    return { ...head, scripts: faqScript(NEWS_FAQ, locale) };
  },
  component: NewsIndex,
  pendingComponent: ContentHubSkeleton,
});

function NewsIndex() {
  const { items, locale } = Route.useLoaderData();
  return (
    <>
      <PageHero eyebrow="News" title="Latest from factory.online" lead="Product releases, partnerships and events — everything happening around factory.online." />
      <Section>
        <FilteredContentGrid
          items={items}
          base="/news"
          locale={locale}
          emptyLabel="Nothing published here yet."
          searchPlaceholder="Search news…"
        />
      </Section>
      <FaqSection faqs={NEWS_FAQ} title="News questions, answered" />
      <ClosingCta />
    </>
  );
}
